module.exports = __webpack_public_path__ + "static/home-callout-02-aef3f1d04dec6eafdc07359b8a688a39.jpg";